import { createRouter, createWebHistory } from 'vue-router'
import FormularioView from '../views/FormularioView.vue'
import EvidenciasView from '../views/EvidenciasView.vue'

const routes = [
  { path: '/', component: FormularioView },
  { path: '/evidencias', component: EvidenciasView }
]

export default createRouter({
  history: createWebHistory(),
  routes
})
